import React from 'react';
import { AcceptedProps } from './interface/accepted-props';
import GeolocationType from './type/geolocation/geolocation';

const GeolocationObject: React.FC<AcceptedProps> = (props) => {
  return <GeolocationType {...props} />
}

export default GeolocationObject;